import type { ReactNode } from "react";
import { I18nProvider } from "@bookingcom/lingojs-react";
import { I18n } from "@bookingcom/lingojs-core";
import { DEFAULT_LOCALE } from "../constants/locale";
import { messages, plural } from "../../dist/locales/en-gb";

const i18n = new I18n(DEFAULT_LOCALE, messages, plural);

export const LingoProvider = ({ children }: { children: ReactNode }) => (
  <I18nProvider store={i18n}>{children}</I18nProvider>
);
